import "antd/dist/antd.css";
import "../../App.scss";
import "./UserDetailsList.scss";

import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  Avatar,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Input,
  message,
  Row,
  Select,
  Space,
  Statistic,
  Table,
  Tooltip,
  Typography,
} from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import qs from "qs";
import Highlighter from "react-highlight-words";
import { Link, useHistory } from "react-router-dom";

/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";

import CustomSearchbar from "../../Components/CustomSearchbar/CustomSearchbar";
import TableUserInfoItem from "../../Components/TableUserInfoItem/TableUserInfoItem";
import { numFormatter } from "../../Utils/formatter";
import { getDateRangeEaring, getDateRangeUserDetails } from "../api/index";

const { Option } = Select;

const userTypeObj = {
  creator: "creator_completed",
  subscriber: "fan_completed",
  dual: "dual",
};

const loaderStyle = {
  position: "fixed",
  top: "45%",
  left: "45%",
  zIndex: 9999,
};

const UserDetailsList = ({ isRestricted = false, allowedFunctions = [] }) => {
  const history = useHistory();

  // Memoized query parameters to prevent re-renders and infinite loops
  const queryParams = useMemo(() => {
    return qs.parse(history.location.search.slice(1));
  }, [history.location.search]);

  const {
    startDate: startDateParam,
    endDate: endDateParam,
    userType: userTypeParam,
  } = queryParams;

  const shouldShowLifetimeUsers = useMemo(() => {
    return Object.keys(queryParams).length === 0;
  }, [queryParams]);

  const [totalOrder, setTotalOrder] = useState(0);
  const [totalEarning, setTotalEarning] = useState(0);
  const [totalCreatorCount, setTotalCreatorCount] = useState(0);
  const [totalSubscriberCount, setTotalSubscriberCount] = useState(0);
  const [totalDualCount, setTotalDualCount] = useState(0);
  const [searchBy, setSearchBy] = useState("name"); // [email, name]
  const [searchFieldText, setSearchFieldText] = useState("");
  const [toggleFilter, setToggleFilter] = useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [userMangoDetails, setuserMangoDetails] = useState([]);
  const [fanMangoDetails, setfanMangoDetails] = useState([]);
  const [startDateState, setStartDateState] = useState(
    shouldShowLifetimeUsers
      ? moment("2020-12-28 14:30:14.755Z").startOf("day")
      : moment().subtract(7, "days").startOf("day")
  );
  const [endDateState, setEndDateState] = useState(moment().startOf("day"));
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [filterUserType, setFilterUserType] = useState(
    userTypeParam || "creator"
  );
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [loader, setLoader] = useState(false);
  const [tableKey, setTableKey] = useState(Date.now());
  const [showLifetimeUsers, setShowLifetimeUsers] = useState(
    shouldShowLifetimeUsers || false
  );

  // Initialize component state from URL parameters or set defaults
  useEffect(() => {
    // If URL has no params, set default lifetime mode
    if (Object.keys(queryParams).length === 0) {
      const lifetimeStartDate = moment("2020-12-28 14:30:14.755Z").startOf(
        "day"
      );
      const lifetimeEndDate = moment().startOf("day");

      setStartDateState(lifetimeStartDate);
      setEndDateState(lifetimeEndDate);
      setFilterUserType("creator");
      setShowLifetimeUsers(true);

      // Update URL with default lifetime params
      const newSearch = `?startDate=${lifetimeStartDate.toISOString()}&endDate=${lifetimeEndDate.toISOString()}&showLifetimeUsers=true&userType=creator`;
      history.replace({
        pathname: history.location.pathname,
        search: newSearch,
      });
      return;
    }

    // Set dates from URL if available
    if (startDateParam && endDateParam) {
      setStartDateState(moment(startDateParam).startOf("day"));
      setEndDateState(moment(endDateParam).endOf("day"));
    }

    // Set user type from URL if available
    if (userTypeParam) {
      setFilterUserType(userTypeParam);
    }
  }, []);

  // Check permissions on mount
  useEffect(() => {
    if (isRestricted && !allowedFunctions.includes("userDetailsList")) {
      history.push("/dashboard/home");
    }
  }, [isRestricted, allowedFunctions, history]);

  const errorHandle = (error) => {
    if (error.status === 401 || error.code === 401) {
      localStorage.clear();
      history.push("/");
      error?.message || error?.result
        ? message.error(error?.message || error?.result)
        : message.error("Something went wrong");
    } else {
      error?.message || error?.result
        ? message.error(error?.message || error?.result)
        : message.error("Something went wrong");
    }
  };

  const onDateChange = useCallback(
    (date) => {
      if (date && date.length === 2) {
        // Valid date range selected
        const startDate = date[0].startOf("day");
        const endDate = date[1].endOf("day");

        setStartDateState(startDate);
        setEndDateState(endDate);
        setShowLifetimeUsers(false);

        // Update URL with new date range
        const newSearch = `?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&userType=${filterUserType}`;
        history.push({
          pathname: history.location.pathname,
          search: newSearch,
        });
      } else if (date === null) {
        // Date range cleared - reset to default 7 days
        const endDate = moment().startOf("day");
        const startDate = moment().subtract(7, "days").startOf("day");

        setStartDateState(startDate);
        setEndDateState(endDate);
        setShowLifetimeUsers(false);

        // Update URL with default date range
        const newSearch = `?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&userType=${filterUserType}`;
        history.push({
          pathname: history.location.pathname,
          search: newSearch,
        });
      }
    },
    [filterUserType, history]
  );

  const reloadUserList = () => {
    setPage(1);
    setToggleFilter(!toggleFilter);
  };

  const handleSearchOptionChange = (value) => {
    setSearchBy(value);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            window.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => window.searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const collectUserData = (response) => {
    if (filterUserType === "creator" || filterUserType === "dual") {
      const mangoDetails = response?.result?.orderDetails?.creatorOrder.reduce(
        (acc, eachMangoDetails) => {
          if (acc[eachMangoDetails?._id?.creatorId]) {
            const userObj = { ...acc[eachMangoDetails?._id?.creatorId] };
            userObj.earing += eachMangoDetails?.totalEarning;
            userObj.order += eachMangoDetails?.totalOrder;
            userObj.mangoes = [
              ...userObj.mangoes,
              {
                ...eachMangoDetails._id,
                totalOrder: eachMangoDetails?.totalOrder,
                totalEarning: eachMangoDetails?.totalEarning,
              },
            ];
            return { ...acc, [eachMangoDetails?._id?.creatorId]: userObj };
          }
          const userObj = {};
          userObj.earing = eachMangoDetails?.totalEarning;
          userObj.order = eachMangoDetails?.totalOrder;
          userObj.mangoes = [
            {
              ...eachMangoDetails._id,
              totalOrder: eachMangoDetails?.totalOrder,
              totalEarning: eachMangoDetails?.totalEarning,
            },
          ];
          return { ...acc, [eachMangoDetails?._id?.creatorId]: userObj };
        },
        {}
      );
      Object.keys(mangoDetails).map((creatorId) => {
        const uniqueMangoes = [];
        const addedIds = [];
        mangoDetails[creatorId].mangoes.map((mango) => {
          if (!addedIds.includes(String(mango.mangoId))) {
            uniqueMangoes.push(mango);
            addedIds.push(String(mango.mangoId));
          } else {
            const exisingIndex = uniqueMangoes.findIndex(
              (existingMango) =>
                existingMango.mangoId.toString() === mango.mangoId.toString()
            );
            uniqueMangoes[exisingIndex] = {
              ...uniqueMangoes[exisingIndex],
              totalEarning:
                uniqueMangoes[exisingIndex].totalEarning + mango.totalEarning,
              totalOrder:
                uniqueMangoes[exisingIndex].totalOrder + mango.totalOrder,
            };
          }
        });
        mangoDetails[creatorId].mangoes = uniqueMangoes;
      });
      setuserMangoDetails(mangoDetails);
    }

    if (filterUserType === "subscriber" || filterUserType === "dual") {
      const mangoDetails = response?.result?.orderDetails?.fanOrder.reduce(
        (acc, eachMangoDetails) => {
          if (acc[eachMangoDetails?._id?.fanId]) {
            const userObj = { ...acc[eachMangoDetails?._id?.fanId] };
            userObj.spend += eachMangoDetails?.totalSpend;
            userObj.order += eachMangoDetails?.totalOrder;
            userObj.mangoList = [
              ...userObj.mangoList,
              {
                ...eachMangoDetails._id,
                totalOrder: eachMangoDetails?.totalOrder,
                totalSpend: eachMangoDetails?.totalSpend,
              },
            ];
            return { ...acc, [eachMangoDetails?._id?.fanId]: userObj };
          }
          const userObj = {};
          userObj.spend = eachMangoDetails?.totalSpend;
          userObj.order = eachMangoDetails?.totalOrder;
          userObj.mangoList = [
            {
              ...eachMangoDetails._id,
              totalOrder: eachMangoDetails?.totalOrder,
              totalSpend: eachMangoDetails?.totalSpend,
            },
          ];
          return { ...acc, [eachMangoDetails?._id?.fanId]: userObj };
        },
        {}
      );
      setfanMangoDetails(mangoDetails);
    }
  };

  const fetchUsers = async (sDate, eDate) => {
    setLoader(true);
    try {
      const resp = await getDateRangeUserDetails(
        sDate,
        eDate,
        false,
        userTypeObj[filterUserType],
        page,
        searchBy,
        searchFieldText
      );
      if (resp?.code === 0) {
        collectUserData(resp);
        setTotalPage(Math.ceil(resp?.result?.userCount / 100));
        setUserDetails(resp?.result);
        setLoader(false);
        setTableKey(Date.now());
      } else {
        setLoader(false);
        errorHandle(resp);
      }
    } catch (error) {
      setLoader(false);
      errorHandle(error);
    }
  };

  const creatorExpandedRowRender = (record) => {
    const columns = [
      {
        title: "Mango Title",
        dataIndex: "mangoName",
        key: "mangoName",
      },
      {
        title: "Price",
        dataIndex: "mangoPrice",
        key: "mangoPrice",
      },
      {
        title: "Total Order",
        dataIndex: "totalOrder",
        key: "totalOrder",
        render: (text, record) => (
          <Typography>
            {userMangoDetails[record.creatorId]
              ? userMangoDetails[record.creatorId].mangoes.find(
                  (mango) => mango.mangoId === record.mangoId
                )?.totalOrder
              : 0}
          </Typography>
        ),
      },
      {
        title: "Content Types",
        dataIndex: "contentType",
        key: "contentType",
        render: (text, record) => (
          <Typography>
            {record.chat && "Chat"} {record.content && "Content"}{" "}
            {record.videocall === 1 && "Video Call"}
          </Typography>
        ),
      },
      {
        title: "Recurring Type",
        dataIndex: "mangoType",
        key: "mangoType",
      },
      {
        title: "Created On",
        dataIndex: "mangoCreationDate",
        key: "mangoCreationDate",
      },
      {
        title: "Active",
        dataIndex: "active",
        key: "active",
        render: (text, record) => (
          <Checkbox
            checked={!(record.mangoIsHidden || record.mangoIsStopTakingPayment)}
          />
        ),
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={record?.mangoList}
        pagination={false}
        bordered
      />
    );
  };

  const subscriberExpandedRowRender = (record) => {
    const columns = [
      {
        title: "Creator Name",
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          <Space size="small">
            <Avatar src={record?.creatorProfilePicUrl} size={32} />
            <Typography
              style={{ fontWeight: 500, fontSize: 14, color: "#1890ff" }}
            >
              {record?.creatorName}
            </Typography>
          </Space>
        ),
      },
      {
        title: "Mango Title",
        dataIndex: "mangoName",
        key: "mangoName",
      },
      {
        title: "Price",
        dataIndex: "amount",
        key: "amount",
      },
      {
        title: "No of time Purchase",
        dataIndex: "totalOrder",
        key: "totalOrder",
      },
      {
        title: "Recurring Type",
        dataIndex: "mangoType",
        key: "mangoType",
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={fanMangoDetails[record?.key]?.mangoList}
        pagination={false}
        bordered
      />
    );
  };

  const displayUserDetails = () => {
    const expandedRowRender = (record) => {
      if (filterUserType === "creator") {
        return creatorExpandedRowRender(record);
      }

      if (filterUserType === "subscriber") {
        return subscriberExpandedRowRender(record);
      }

      if (filterUserType === "dual") {
        return (
          <>
            <div>{creatorExpandedRowRender(record)}</div>
            <div>{subscriberExpandedRowRender(record)}</div>
          </>
        );
      }
    };

    let userBaseColumn = [];
    const fanColumn = [
      {
        title: "Total Spend",
        dataIndex: "totalSpend",
        key: "totalSpend",
        render: (text, record) => (
          <Typography>
            {fanMangoDetails[record.key]
              ? fanMangoDetails[record.key].spend
              : 0}
          </Typography>
        ),
      },
      {
        title: "Total Mango Purchase",
        dataIndex: "totalMangoPurchase",
        key: "totalMangoPurchase",
        render: (text, record) => (
          <Typography>
            {fanMangoDetails[record.key]
              ? fanMangoDetails[record.key].order
              : 0}
          </Typography>
        ),
      },
      {
        title: "Unique Creator",
        dataIndex: "uniqueCreator",
        key: "uniqueCreator",
        render: (text, record) => (
          <Typography>
            {fanMangoDetails[record.key]
              ? Object.values(
                  fanMangoDetails[record.key].mangoList.reduce((acc, mango) => {
                    return { ...acc, [mango.creatorId]: 1 };
                  }, {})
                ).length
              : 0}
          </Typography>
        ),
      },
    ];

    if (filterUserType === "creator" || filterUserType === "dual") {
      userBaseColumn = [
        {
          title: "Earning",
          dataIndex: "earning",
          key: "earning",
        },
        {
          title: "Total Order",
          dataIndex: "order",
          key: "order",
        },
        {
          title: "Active Mango/ Mango",
          dataIndex: "activeMango",
          key: "activeMango",
          render: (text, record) => (
            <Typography>
              {record?.activeMango} / {record?.numberOfMangoes}
            </Typography>
          ),
        },
        ...((filterUserType === "dual" && fanColumn) || []),
      ];
    }

    if (filterUserType === "subscriber") {
      userBaseColumn = fanColumn;
    }

    const columnData = [
      {
        title: "User Info",
        dataIndex: "name",
        key: "userInfo",
        width: 250,

        render: (_, record) => (
          <Link to={`/dashboard/user-details/${record?.key}`}>
            <TableUserInfoItem
              name={record?.name}
              profilePic={record?.profilePicUrl}
              email={record?.email}
              phone={record?.phone}
              isCopyable
            />
          </Link>
        ),
      },
      ...userBaseColumn,
      {
        title: "Joining Date",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text, record) => (
          <Typography>
            {moment(record?.createdAt).format("MMMM Do YYYY, h:mm:ss a")}
          </Typography>
        ),
      },
    ];

    let data = [];

    if (filterUserType === "creator" || filterUserType === "dual") {
      data = userDetails?.fetchedUser
        ? userDetails?.fetchedUser.map((record) => ({
            name: record?._id?.creatorName,
            profilePicUrl: record?._id?.creatorProfilePicUrl,
            earning: userMangoDetails[record?._id?.creatorId]?.earing || 0,
            order: userMangoDetails[record?._id?.creatorId]?.order || 0,
            activeMango: record?.mangoList?.filter(
              (eachMango) =>
                !(eachMango.mangoIsHidden || eachMango.mangoIsStopTakingPayment)
            ).length,
            numberOfMangoes: record?.numberOfMangoes,
            email: record?._id?.creatorEmail,
            phone: record?._id?.creatorPhone,
            createdAt: record?._id?.createdAt,
            key: record?._id?.creatorId,
            mangoList: record?.mangoList,
          }))
        : [];
    }

    if (filterUserType === "subscriber") {
      data = userDetails?.fetchedUser
        ? userDetails?.fetchedUser.map((record) => ({
            name: record?.name,
            profilePicUrl: record?.profilePicUrl,
            email: record?.email,
            phone: record?.phone,
            createdAt: record?._id?.createdAt,
            key: record?._id,
          }))
        : [];
    }

    return (
      <>
        <Table
          key={tableKey}
          loading={loader}
          columns={columnData}
          dataSource={loader ? [] : data}
          expandable={{ expandedRowRender }}
          pagination={{
            current: page,
            pageSize: 20,
            total: totalPage * 20,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            onChange: (newPage, newPageSize) => {
              setPage(newPage);
            },
            onShowSizeChange: (current, size) => {
              setPage(1);
            },
          }}
          locale={{
            emptyText: loader ? "Loading..." : "No users found",
          }}
          scroll={{ x: "auto" }}
        />
      </>
    );
  };

  useEffect(() => {
    // Don't fetch data if user doesn't have permission
    if (isRestricted && !allowedFunctions.includes("userDetailsList")) {
      return;
    }

    setTotalCreatorCount(0);
    setTotalDualCount(0);
    setTotalSubscriberCount(0);

    fetchUsers(startDateState.toISOString(), endDateState.toISOString());
    getDateRangeEaring(
      startDateState.toISOString(),
      endDateState.toISOString(),
      true,
      undefined,
      searchBy,
      searchFieldText
    )
      .then((response) => {
        if (response.code === 0) {
          setTotalOrder(response?.result[0]?.totalOrder);
          setTotalEarning(response?.result[0]?.totalEarning);
        }
        // console.log(response);
      })
      .catch((error) => {
        errorHandle(error);
      });
    getDateRangeUserDetails(
      startDateState.toISOString(),
      endDateState.toISOString(),
      true,
      undefined,
      undefined,
      searchBy,
      searchFieldText
    )
      .then((response) => {
        if (response.code === 0) {
          response?.result.forEach((element) => {
            if (element?._id?.onboarding === "creator_completed") {
              setTotalCreatorCount(element?.totalCount);
            }
            if (element?._id?.onboarding === "dual") {
              setTotalDualCount(element?.totalCount);
            }
            if (element?._id?.onboarding === "fan_completed") {
              setTotalSubscriberCount(element?.totalCount);
            }
          });
        }
      })
      .catch((error) => {
        errorHandle(error);
      });
  }, [
    startDateState,
    endDateState,
    filterUserType,
    page,
    toggleFilter,
    searchBy,
    searchFieldText,
    isRestricted,
    allowedFunctions,
  ]);

  const toggleLifetime = useCallback(() => {
    if (showLifetimeUsers) {
      // Turn OFF lifetime mode - set to last 7 days
      const endDate = moment().startOf("day");
      const startDate = moment().subtract(7, "days").startOf("day");

      setStartDateState(startDate);
      setEndDateState(endDate);
      setShowLifetimeUsers(false);

      // Update URL without showLifetimeUsers parameter
      const newSearch = `?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&userType=${filterUserType}`;
      history.push({
        pathname: history.location.pathname,
        search: newSearch,
      });
    } else {
      // Turn ON lifetime mode - add showLifetimeUsers=true parameter
      const lifetimeStartDate = moment("2020-12-28 14:30:14.755Z").startOf(
        "day"
      );
      const lifetimeEndDate = moment().startOf("day");

      setStartDateState(lifetimeStartDate);
      setEndDateState(lifetimeEndDate);
      setShowLifetimeUsers(true);

      // Update URL with showLifetimeUsers=true parameter
      const newSearch = `?startDate=${lifetimeStartDate.toISOString()}&endDate=${lifetimeEndDate.toISOString()}&showLifetimeUsers=true&userType=${filterUserType}`;
      history.push({
        pathname: history.location.pathname,
        search: newSearch,
      });
    }
  }, [showLifetimeUsers, filterUserType, history]);

  return (
    <>
      <div className="site-stats-wrapper">
        <Row gutter={[24, 16]} style={{ marginBottom: "24px" }}>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Total Orders"
                value={totalOrder}
                formatter={(value) =>
                  numFormatter({
                    amount: value,
                    hideCurrency: true,
                    hideTooltip: true,
                  })
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Total Creators"
                value={Number(totalDualCount) + Number(totalCreatorCount) || 0}
                formatter={(value) =>
                  numFormatter({
                    amount: value,
                    hideCurrency: true,
                    hideTooltip: true,
                  })
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Total Subscribers"
                value={
                  Number(totalDualCount) + Number(totalSubscriberCount) || 0
                }
                formatter={(value) =>
                  numFormatter({
                    amount: value,
                    hideCurrency: true,
                    hideTooltip: true,
                  })
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Total Earnings"
                value={totalEarning}
                formatter={(value) =>
                  numFormatter({
                    amount: value,
                    currency: "INR",
                  })
                }
              />
            </Card>
          </Col>
        </Row>

        {/* Filters Row */}
        <div style={{ marginBottom: "24px" }}>
          {/* Search Row */}
          <Row
            gutter={[16, 16]}
            style={{ marginBottom: 16, flexWrap: "nowrap" }}
            align="middle"
          >
            <Col style={{ width: "100%" }}>
              <Input.Group
                compact
                style={{ display: "flex", width: "100%" }}
                className="group-searchbar"
              >
                <Tooltip title="Search by">
                  <Select
                    size="large"
                    style={{ width: "150px", flexShrink: 0 }}
                    onChange={handleSearchOptionChange}
                    value={searchBy}
                    placeholder="Search by"
                  >
                    <Option value="name">Name</Option>
                    <Option value="email">Email</Option>
                    <Option value="phone">Phone</Option>
                  </Select>
                </Tooltip>
                <CustomSearchbar
                  placeholder={`Search by ${searchBy}`}
                  searchQuery={searchFieldText}
                  setSearchQuery={setSearchFieldText}
                  style={{
                    marginBottom: 0,
                    flex: 1,
                    minWidth: 0,
                  }}
                />
              </Input.Group>
            </Col>

            <Tooltip title="Refresh">
              <Button
                size="large"
                onClick={reloadUserList}
                style={{ flexShrink: 0 }}
                icon={<ReloadOutlined />}
              />
            </Tooltip>
          </Row>

          {/* Filters Row */}
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={8} lg={6}>
              <Tooltip title="Choose user type">
                <Select
                  size="large"
                  style={{ width: "100%" }}
                  onChange={(value) => setFilterUserType(value)}
                  value={filterUserType}
                  placeholder="Select User Type"
                >
                  <Option value="creator">Creator</Option>
                  <Option value="subscriber">Customer</Option>
                  <Option value="dual">Dual</Option>
                </Select>
              </Tooltip>
            </Col>

            <Col xs={24} sm={16} lg={18}>
              <Space size="middle" align="center" style={{ width: "100%" }}>
                <DatePicker.RangePicker
                  size="large"
                  disabled={showLifetimeUsers}
                  onChange={onDateChange}
                  value={
                    showLifetimeUsers ? null : [startDateState, endDateState]
                  }
                  allowClear
                  placeholder={["Start Date", "End Date"]}
                  style={{ width: 300 }}
                />

                <Checkbox checked={showLifetimeUsers} onChange={toggleLifetime}>
                  Show lifetime users
                </Checkbox>
              </Space>
            </Col>
          </Row>
        </div>
      </div>

      {displayUserDetails()}
    </>
  );
};

UserDetailsList.propTypes = {
  isRestricted: PropTypes.bool,
  allowedFunctions: PropTypes.arrayOf(PropTypes.string),
};

UserDetailsList.defaultProps = {
  isRestricted: false,
  allowedFunctions: [],
};

export default UserDetailsList;
